import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormData, Module } from 'components/misc'
import { Input, Select, Textarea } from 'components/fields'
import { FormattedMessage, injectIntl } from 'react-intl'
import { apiAssessors, apiConfiguration } from 'helpers/decorators/api'
import assessorsDropdownSelector from '../../../../redux/selectors/assessors/assessorsDropdownSelector'
import {
  ACTIVITY_CATEGORIES
} from '../../../../constants/enums'
import { get } from 'lodash'

@injectIntl
@apiConfiguration()
@apiAssessors()
class AJAssessor extends Component {
  static propTypes = {
    intlKey: PropTypes.string,
    title: PropTypes.string,
    disabledIntlKey: PropTypes.string,
    disabledDefault: PropTypes.string,
    formPrefix: PropTypes.string,
    titles: PropTypes.array,
    showReason: PropTypes.bool,
    supervisor: PropTypes.bool.isRequired,
    subcategoryValue: PropTypes.oneOf(PropTypes.number, PropTypes.string),
    setupAssessorId: PropTypes.number,
    setupSupervisorId: PropTypes.number,
    assessors: PropTypes.object.isRequired,
    isAssessorManagementEnabled: PropTypes.bool.isRequired,
    isCreatedByParticipant: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired,
    ajEvents: PropTypes.object.isRequired,
    initialize: PropTypes.func.isRequired,
    change: PropTypes.func,
    orgId: PropTypes.number,
    values: PropTypes.object
  }

  static defaultProps = {
    intlKey: 'supervisor',
    title: 'Supervisor',
    disabledIntlKey: 'label.assessor_disabled_for_other_activity',
    disabledDefault: 'Assessor selection is disabled for other activity.',
    titles: [],
    formPrefix: 'supervisor',
    supervisor: false
  }


  componentDidMount() {
    const { isAssessorManagementEnabled, ajEvents, initialize, values } = this.props

    const initObj = { ...get(ajEvents), ...values }

    initObj['transportationModes'] = this.mapTransportationMode(get(ajEvents, 'detail.transportationModes'))

      if (isAssessorManagementEnabled) {

        if (ajEvents) {

          if(get(ajEvents, 'detail.assessor.id')){
            initObj['setupAssessorId'] = get(ajEvents, 'detail.assessor.id')
          } else {
            initObj['setupAssessorId'] = 0
          }
        } else {
          initObj['setupAssessorId'] = 0
        }
      }


    initialize(initObj)
  }



  componentWillReceiveProps(nextProps) {

     if (this.props.data !== nextProps.data ||
         this.props.isAssessorManagementEnabled !== nextProps.isAssessorManagementEnabled ||
        this.props.orgId !== nextProps.orgId
    ) {
       const { initialize } = this.props

       const initObj = { ...get(nextProps.ajEvents, 'detail'), ...get(nextProps, 'values') }

       const transportationModes = get(nextProps, 'values.transportationModes')

       initObj['transportationModes'] = transportationModes || this.mapTransportationMode(get(nextProps.ajEvents, 'detail.transportationModes'))

      if (nextProps.isAssessorManagementEnabled) {
        if (nextProps.ajEvents) {
          if(get(nextProps.ajEvents, 'detail.assessor.id')){
            initObj['setupAssessorId'] = get(nextProps.ajEvents, 'detail.assessor.id')
          } else {
            initObj['setupAssessorId'] = 0
          }
        } else {
          initObj['setupAssessorId'] = 0
        }
      }
       initialize(initObj)
    }
  }

  mapTransportationMode = (transportationModes) => {
    const transportationModeList = transportationModes && transportationModes.map(item => {
      return {
        id: get(item, 'transportationMode.id'),
        value: get(item, 'transportationMode.modeOfTransportType.value'),
        label: get(item, 'transportationMode.modeOfTransportType.translationText')
      }
    })

    return transportationModeList
  }

  clearForm = isAssessorManagementEnabled => {

    if(isAssessorManagementEnabled && this.props.data !== null){
      this.props.change('assessorEmail', null)
      this.props.change('assessorPhone', null)
      this.props.change('assessorName', null)
      this.props.change('assessorTitle', null)
      this.props.change('assessorRelevantExperience', null)
    }

  }

  capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  render() {
    const { intlKey, title,
      formPrefix, titles, showReason, supervisor,
      subcategoryValue, setupAssessorId, assessors, isAssessorManagementEnabled
    } = this.props

    const isOthersSubCategory = subcategoryValue === ACTIVITY_CATEGORIES.other.id

    const isSelectedAssessor = setupAssessorId > 0

    const isNewAssessor = setupAssessorId === 0

    const otherCondition = (isOthersSubCategory && !isNewAssessor && (!isSelectedAssessor || setupAssessorId === undefined))

    const hideFields = (isAssessorManagementEnabled && !supervisor) && (otherCondition || (!subcategoryValue && !isOthersSubCategory) || isSelectedAssessor || setupAssessorId === null)

    let dropdownAssessors = assessorsDropdownSelector(assessors, this.props)

    return (<Module title={title} intlKey={intlKey} primary grid>
      {!supervisor && <div style={{ marginBottom: '10px', color: 'rgba(78,78,78,0.7)' }}>
        <FormattedMessage
          id="info.aj_supervisor_is_mandatory"
          defaultMessage="For the Practice Journey the Supervisor will receive the assessment request and for the Qualifying Journey the Assessor will receive the assessment request."
        />
      </div>}

      {isAssessorManagementEnabled && !supervisor && <div>

        {!supervisor && <div className="row">
          <div className="col-xs-12">
            <Select
              name={`setup${this.capitalizeFirstLetter(formPrefix)}Id`}
              label=""
              intlKey=""
              options={dropdownAssessors}
              disabled={!subcategoryValue}
              onSelectChange={() => this.clearForm(isAssessorManagementEnabled)}
            />
          </div>
        </div>}
      </div>}

      {!hideFields && <div>
        <div className="row">
          <div className="col-xs-6">
            <Select
              label="Title"
              name={`${formPrefix}Title`}
              intlKey="label.title"
              options={titles}
            />
          </div>
          <div className="col-xs-6">
            <Input label="Name" name={`${formPrefix}Name`} intlKey="label.name" />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Input
              label="Email"
              name={`${formPrefix}Email`}
              intlKey="label.email"
             />
          </div>
          <div className="col-xs-6">
            <Input
              label="Phone"
              name={`${formPrefix}Phone`}
              intlKey="label.phone"
            />
          </div>
        </div>
      </div>}

      {isAssessorManagementEnabled && !supervisor && <div className="row">
          <div className="col-xs-12">
            <FormData label="State" intlKey="label.state">
              {get(this.props, 'ajEvents.detail.assessorRegistrationState') || '---'}
            </FormData>
          </div>
      </div>}

      {showReason && (
        <div className="row">
          <div className="col-xs-12">
            <Textarea
              label="Reason for changing the assessor"
              intlKey="label.reason_for_changing_assessor"
              name="reasonForChangingAssessor"
            />
          </div>
        </div>
      )}
    </Module>)
  }
}

export default AJAssessor
